import React, { Component, useState, useEffect } from "react";
import * as firebase from 'firebase'
//import {db} from '../../utils/ipa.js';
import {Content,Form,Item,Input,Container,Label,Text,DatePicker,Button } from "native-base";
import Sentry from '../../utils/Sentry'


//const userProfileRef = db.collection('Profiles').doc('1vPJgKqeBEgXMD6yolzugGJUvcW2')

// function onSubmit(firstName, lastName) {
//   userProfileRef.update({
//     FirstName: firstName,
//     LastName: lastName
//   })
// }

export default function PersonalInfoScreen({ routes,navigation }) {
   
  const [lastName, setLastName] = useState('')
  const [firstName, setFirstName] = useState('')
  const [DOB, setDOB] = useState('')
  const [zipCode, setZipCode] = useState(0)

  useEffect(() => {
    userProfileRef.get().then((doc) => {
      setLastName(doc.data().LastName), 
      setFirstName(doc.data().FirstName),
      setZipCode(doc.data().ZipCode)
      //setDOB(doc.data().DOB)
    });
  }, []);

  const onSubmit = e => {
    try {
      userProfileRef.update({
        FirstName: firstName,
        LastName: lastName,
        ZipCode: zipCode
      })
    } catch (error) {
      Sentry.captureException(error)
    }
  }

  return (
    <Container>
      <Content>
        <Form>
          <Item fixedLabel>
            <Label>First Name</Label>
            <Input 
              placeholder="First Name" 
              value={firstName} 
              onChangeText={(text) => setFirstName(text)} 
              />
          </Item>
          <Item fixedLabel>
            <Label>Last Name</Label>
            <Input 
              placeholder="Last Name" 
              value={lastName}
              onChangeText={(text) => setLastName(text)}  
              />
          </Item>
          <Item fixedLabel>
            <Label>Zip Code</Label>
            <Input 
              placeholder="Zip Code"
              value={zipCode}
              onChangeText={(text) => setZipCode(text)}
              autoCompleteType="postal-code"
            />
          </Item>
          <Button 
            onPress={e => onSubmit()}
          >
            <Text>Save</Text>
          </Button>
        </Form>
      </Content>
    </Container>
  )
}
